const LIVESTREAM_TYPE_OPTIONS = {
  LIVESTREAM_STATIC: 'STATIC',
  LIVESTREAM_LITE: 'LITE',
  LIVESTREAM_PLUS: 'PLUS',
  LIVESTREAM_PRO: 'PRO',
}

export default LIVESTREAM_TYPE_OPTIONS
